import styled from 'styled-components'

// Note: the keyless card is its own column, the provider cards pack into columns next to it
// and the whole thing wraps below each other when there is no room for both
export const ClassicLayout = styled.div(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['16'],
}))

export const LeadColumn = styled.div({
  flex: '1 1 30rem',
})

// Note: at most 3 columns, filled row by row; the cards come sorted by size so each row holds
// cards of about the same height and their headers line up
export const RestGrid = styled.div(({ theme }) => ({
  alignItems: 'start',
  display: 'grid',
  flex: '3 1 62rem',
  gap: theme.space['16'],
  gridTemplateColumns: `repeat(auto-fill, minmax(max(26rem, calc((100% - 2 * ${theme.space['16']}) / 3)), 1fr))`,
  minWidth: 0,
}))
